module.exports = __webpack_public_path__ + "img/banner4.abbf0862.webp";